/**
 * 
 * Save search to email functions
 * 
 */

import { reservaD } from "./variables";
import { dId, showError, logger} from "./utils";
import { ajax_save_search } from "./ajax";
import { langDict } from "./dict";

export async function guardarmireserva_build() {

	logger("Save user reserva", "log");

	const regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
	const regMobile = /^([67])+([0-9]{8})$/;
	
	let eml = (<HTMLInputElement>dId("savesearch_email")).value.trim();

	if ( regEmail.test(eml)===false && regMobile.test(eml)===false) {
	
		showError(langDict[67]);
		return;
	
	}

	(<HTMLInputElement>dId("savesearch_fire")).disabled = true;

	const URLreturn = "https://www.autofurgo.es/alquiler-busqueda/?cl=";
	
	const return_url = URLreturn + "&tipo_c=recuperar&" + "&tipo_v=" + reservaD[7] + "&prov=" + reservaD[15] + "&provd=" + reservaD[16] + "&city=" + reservaD[12] + "&cityd=" + reservaD[13] + "&desde=" + reservaD[1] + "&hasta=" + reservaD[3] + "&hdesde=" + reservaD[2] + "&hhasta=" + reservaD[4] + "&edad=" + reservaD[14] + "&lang=" + reservaD[86] + "&g_cid=" + reservaD[96];

	// Load AJAX office options: 
	let res = await ajax_save_search( return_url, reservaD[81], eml );

	if (res.status == "ERROR") {

		showError(langDict[68]);
		(<HTMLInputElement>dId("savesearch_fire")).disabled = false;

	} else {

		let target = (<HTMLElement>dId("saveSearch"));
		let previousHTML = target.innerHTML;

		target.innerHTML = langDict[69];

		setTimeout(function () {
			target.innerHTML = previousHTML;
			(<HTMLInputElement>dId("savesearch_fire")).disabled = false;
		}, 5000);

	}


}